import { useHistory } from "react-router";
import { Col, Space } from "antd";
// import { Auth } from "aws-amplify";
import { useCallback, useEffect } from "react";
import { Button } from "../../components";
import { useGetAppType } from "../../customhooks";
import { searchPageIcon } from "../../svgs";
import { checkIsFDAMode, getEnvVariables, getLoginUrl } from "../../utils";
import { LoginStyled } from "./loginpage.styles";
import LinkButton from "../../components/linkbutton/linkbutton";
import { LoginPageWrapperStyled } from "./loginpagewrapper.styles";
import DesktopLoginPage from "./desktoploginpage/desktoploginpage";
import ExtensionLoginPage from "./extensionloginpage/extensionloginpage";
import { APP_ROUTES } from "../../constants";

function Login({ isExtLogin }: { isExtLogin?: boolean }): JSX.Element {
  const {
    REACT_APP_CHROME_EXT_ID: chromeExtId,
    REACT_APP_DVSUM_GET_STARTED_URL: getStartedUrl,
  } = getEnvVariables();

  const { isExtWindow, isDesktopApp, isExtOrDesktop } = useGetAppType();
  // const isFDAMode = checkIsFDAMode();
  const history = useHistory();

  const onLoginBtnClicked = useCallback(() => {
    if (isExtWindow) {
      // eslint-disable-next-line no-undef
      chrome?.runtime?.sendMessage(chromeExtId, {
        action: "createSigninWindow",
      });
    } else {
      window.location.href = getLoginUrl();
    }

    // else if (isFDAMode) {
    //   window.location.href = getLoginUrl();
    // } else {
    //   Auth.federatedSignIn();
    // }
  }, [chromeExtId]);

  const onSignUpBtnClicked = useCallback(() => {
    isExtOrDesktop
      ? window.open(getStartedUrl)
      : (window.location.href = getStartedUrl);

    // isExtOrDesktop
    //   ? isFDAMode
    //     ? window.open(APP_ROUTES.auth_routes.email_verification)
    //     : window.open(getStartedUrl)
    //   : isFDAMode
    //   ? history.push(APP_ROUTES.auth_routes.email_verification)
    //   : (window.location.href = getStartedUrl);
  }, [isExtOrDesktop]);

  useEffect(() => {
    if (isExtLogin) {
      window.location.href = getLoginUrl();
      // if (isFDAMode) {
      //   window.location.href = getLoginUrl();
      // } else {
      //   Auth.federatedSignIn();
      // }
    }
  }, [isExtLogin]);

  return isExtLogin ? (
    <div />
  ) : (
    <LoginPageWrapperStyled>
      {isDesktopApp ? (
        <DesktopLoginPage
          className="wrapper-content"
          onLoginBtnClicked={onLoginBtnClicked}
          onSignUpBtnClicked={onSignUpBtnClicked}
        />
      ) : isExtWindow ? (
        <ExtensionLoginPage
          className="wrapper-content"
          onLoginBtnClicked={onLoginBtnClicked}
          onSignUpBtnClicked={onSignUpBtnClicked}
        />
      ) : (
        <LoginStyled className="wrapper-content">
          <>
            <Col className="a-section left-section">
              <div className="content-container">
                <div className="dvsum-log">
                  <img src="/assets/dvsum-logo-2.png" />
                </div>
                <div className="header">
                  Data Insights Platform
                  <div className="header-description">
                    Make your data smart, safe, reliable, and conversational.
                  </div>
                </div>

                <div className="icon-container">
                  {searchPageIcon("101", "101")}
                </div>

                <div className="description">Sign-in to your account</div>

                <div className="login-btn-container">
                  <Button className="login-btn" onClick={onLoginBtnClicked}>
                    Sign In
                  </Button>
                </div>

                {!checkIsFDAMode() && (
                  <div className="sign-up-container">
                    <Space size={6} wrap align="center">
                      Don't have a DvSum account?
                      <LinkButton
                        className="sign-up-btn"
                        onClick={onSignUpBtnClicked}
                      >
                        <u>Sign Up</u>
                      </LinkButton>
                    </Space>
                  </div>
                )}
              </div>
            </Col>
            <div className="a-section right-section">
              <img src="/assets/landing-page-lady.png" />
            </div>
          </>
        </LoginStyled>
      )}
    </LoginPageWrapperStyled>
  );
}

export default Login;
